import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShieldIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shield"}/>
}
